import React, { useEffect } from "react";
import { Reflector, useTexture } from "@react-three/drei";
import useStore from "../modules/useStore";

export default function Ground({ ...props }) {
  const { projects, size } = useStore(({projects}) => ({
    projects,
    size: projects.length * 10 + 60,
  }));
  const [floor, normal] = useTexture([
    "/SurfaceImperfections003_1K_var1.jpg",
    "/SurfaceImperfections003_1K_Normal.jpg",
  ]);
  useEffect(() => {
    // floor.repeat = [10, 10];
    // normal.repeat = [10, 10];
  }, [floor, normal]);
  return (
    <>
    <Reflector
      resolution={1024}
      // args={[20, 10]}
      args={[size, size]}
      mirror={.4}
      mixBlur={0}
      mixStrength={1}
      rotation={[-Math.PI / 2, 0, Math.PI / 2]}
      // blur={[400, 100]}
      position={[0, 0, 1]}
      {...props}
    >
      {(Material, props) => (
        <Material
          color="white"
          metalness={0.5}
          roughnessMap={floor}
          normalMap={normal}
          normalScale={[1, 1]}
          {...props}
        />
      )}
    </Reflector>
    {/* {projects.map((_, index) => <Reflector
      resolution={256}
      args={[20, 10]}
      //   args={[size, size]}
      mirror={.4}
      mixBlur={3}
      mixStrength={1}
      rotation={[-Math.PI / 2, 0, Math.PI / 2]}
      blur={[400, 100]}
      position={[index * 10, 0, 1]}
      {...props}
    >
      {(Material, props) => (
        <Material
          color="white"
          metalness={0.5}
          roughnessMap={floor}
          normalMap={normal}
          normalScale={[1, 1]}
          {...props}
        />
      )}
    </Reflector>)} */}
    </>
  );
}
